module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    style: ({
      width: '100%'
    }),
    attrs: {
      "options": _vm.addressOptions,
      "props": _vm.cascaderProps,
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择省市区"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8582a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/utils/cascader.vue
// module id = 996
// module chunks = 3